import { css } from '@emotion/react';
import { FC, useContext, useEffect } from 'react';
import { useAppTranslation } from '@hooks/useAppTranslation';
import { TAudienceType, CurrentUserRole } from '@definitions/states';
import { ProjectType } from '@pages/types';
import { Button, Form, FormElements } from 'common-components';
import { LoadingOutlined } from '@ant-design/icons';

import { AudienceCollapse } from '../shared';

import { AudienceContext } from '@/context';
import { store } from '@/store';

export const audienceCollapsesOverride = css`
  .ant-collapse {
    border: none !important;
  }

  .ant-collapse-item:last-child {
    border-bottom: none !important;
  }

  .ant-collapse-title > .ant-row {
    padding: 0 0 16px !important;
  }

  .ant-collapse-title h5.ant-typography {
    font-size: 18px;
    line-height: 28px;
  }

  .ant-collapse-body > div {
    padding: 0 !important;
  }
`;

type AudienceContributorsPropsType = {
  project: ProjectType
  timePerTaskForm: string
};

const ContributorsAudienceProject: FC<AudienceContributorsPropsType> = ({
  project,
  timePerTaskForm,
}) => {
  const { translate } = useAppTranslation();
  const [form] = FormElements.useForm();

  const modifEnabled =
    CurrentUserRole[project.currentUserRole] === 'admin' ||
    CurrentUserRole[project.currentUserRole] === 'creator';

  const updateAudienceProjectAction = store.use.updateAudienceProjectAction().call;

  const isLoadingUpdateAudienceProjectAction =
    store.use.updateAudienceProjectAction().status === 'LOADING';

  const { setAudience, audience } = useContext(AudienceContext);

  const handleSubmit = async (values: ProjectType['audience']) => {
    // TODO - Do not delete "values", for future use
    if (!project) return;
    updateAudienceProjectAction({
      idProject: project.idProject,
      audience: {
        audienceType: (values.audienceType as TAudienceType) || 0,
        audienceGroups: audience.audienceGroups,
        combination: audience.combination,
        supplierEarning: values.supplierEarning,
      },
    });
  };

  useEffect(() => {
    if (project?.audience) {
      setAudience('contributors', {
        audienceGroups: project.audience.audienceGroups,
        combination: project.audience.combination,
      });
    }
  }, [project?.audience]);

  return (
    <Form form={form} onFinish={handleSubmit}>
      <div css={audienceCollapsesOverride}>
        <AudienceCollapse
          type="contributors"
          projectId={project?.idProject}
          audience={audience?.audienceGroups}
          combination={audience?.combination}
          audienceType={project?.audience?.audienceType}
          selectedEarnings={project?.audience?.supplierEarning}
          timePerTask={timePerTaskForm}
          withCollapseTitle={false}
        />
      </div>
      <Button
        type="primary"
        disabled={isLoadingUpdateAudienceProjectAction || !modifEnabled}
        htmlType="submit"
        size="sm"
        style={{ marginTop: 16 }}
      >
        {isLoadingUpdateAudienceProjectAction ? (
          <LoadingOutlined />
        ) : (
          translate('project.audience.buttons.saveChanges')
        )}
      </Button>
    </Form>
  );
};

export default ContributorsAudienceProject;
